import CourtCaseParamMapper from "../../caseLawDocuments/service/CourtCaseParamMapper";
import { IHttpService } from "../../core/service/HttpService";
import Constants from "../common/Constants";
import { ICaseDecision } from "../model/CaseDecision";
import { IInvalidatedCaseDecision } from "../model/InvalidatedCaseDecision";
import CaseDecisionMapper from "./CaseDecisionMapper";
import CaseDecisionParamMapper from "./CaseDecisionParamMapper";

export interface ICaseDecisionService {
  createCaseDecision(
    item: ICaseDecision,
    indexes: number[],
    courtCase?: any,
    invalidatedCaseDecisions?: IInvalidatedCaseDecision
  ): Promise<ICaseDecision>;
  updateCaseDecision(
    item: ICaseDecision,
    indexes: number[],
    courtCase?: any,
    invalidatedCaseDecisions?: IInvalidatedCaseDecision
  ): void;
  publishCaseDecision(caseDecisionId: string): Promise<ICaseDecision>;
  archiveCaseDecision(caseDecisionId: string): Promise<ICaseDecision>;
  revertCaseDecisionStatus(caseDecisionId: string): Promise<ICaseDecision>;
}

const CaseDecisionService = ({ httpService }): ICaseDecisionService => {
  const _http: IHttpService = httpService;
  const _baseUrl: string = "/api";
  return {
    async createCaseDecision(
      item: ICaseDecision,
      indexes: number[],
      courtCase: any = undefined,
      invalidatedCaseDecisions: IInvalidatedCaseDecision
    ) {
      const path = _http.buildPath(_baseUrl, Constants.endpointBasePath);
      const caseDecisionCreation = {
        caseDecision: CaseDecisionParamMapper(item),
        courtCase: CourtCaseParamMapper(courtCase),
        invalidatedCaseDecisions: invalidatedCaseDecisions,
        indexes: indexes
      };
      const response = await _http.post(path, {
        form: false,
        params: caseDecisionCreation
      });
      const responseJSON = await _http.toJSON(response);
      return CaseDecisionMapper(responseJSON);
    },

    async updateCaseDecision(
      item: ICaseDecision,
      indexes: number[],
      courtCase: any = undefined,
      invalidatedCaseDecisions: IInvalidatedCaseDecision
    ) {
      const path = _http.buildPath(
        _baseUrl,
        Constants.endpointBasePath,
        item.id
      );
      const caseDecisionCreation = {
        caseDecision: CaseDecisionParamMapper(item),
        courtCase: CourtCaseParamMapper(courtCase),
        invalidatedCaseDecisions: invalidatedCaseDecisions,
        indexes: indexes
      };
      await _http.put(path, {
        form: false,
        params: caseDecisionCreation
      });
    },

    async publishCaseDecision(caseDecisionId: string) {
      const path = _http.buildPath(
        _baseUrl,
        Constants.endpointBasePath,
        caseDecisionId,
        "publish"
      );
      const response = await _http.post(path, {
        form: false
      });
      const responseJSON = await _http.toJSON(response);
      return CaseDecisionMapper(responseJSON);
    },

    async archiveCaseDecision(caseDecisionId: string) {
      const path = _http.buildPath(
        _baseUrl,
        Constants.endpointBasePath,
        caseDecisionId,
        "archive"
      );
      const response = await _http.post(path, {
        form: false
      });
      const responseJSON = await _http.toJSON(response);
      return CaseDecisionMapper(responseJSON);
    },

    async revertCaseDecisionStatus(caseDecisionId: string) {
      const path = _http.buildPath(
        _baseUrl,
        Constants.endpointBasePath,
        caseDecisionId.toString(),
        "status-revert"
      );
      const response = await _http.post(path, {
        form: false
      });
      const responseJSON = await _http.toJSON(response);
      return CaseDecisionMapper(responseJSON);
    }
  };
};

export default CaseDecisionService;
